<template>
<div class="factor-finger-wrapper">
  <div>
    <e-chart ref="chart" />
  </div>

  <div class="source-name-wrapper">
    <div class="source-name-list">
      <template v-for="(sourceNameConfig, index) in sourceNameConfigs">
        <template v-if="editSourceName === sourceNameConfig.name">
          <span :key="`color-section-${index}`" class="color-section" :style="{
            'background-color': tmpSourceColor
          }"></span>
          <el-select
            :key="`name-select-${index}`"
            v-model="tmpSourceName"
            size="mini"
            style="width:100px;"
            @change="onTmpSourceNameChange"
          >
            <el-option
              v-for="selectOption in selectOptions"
              :key="selectOption.id"
              :value="selectOption.id"
              :label="selectOption.name"
            />
          </el-select>
          <span :key="`ok-btn-${index}`" class="ok-btn" @click="onOKBtnClick"><i class="el-icon-success"></i></span>
          <span :key="`cancel-btn-${index}`" class="cancel-btn" @click="onCancelBtnClick"><i class="el-icon-circle-close"></i></span>
        </template>
        <template v-else>
          <span :key="`color-section-${index}`" class="color-section" :style="{
            'background-color': sourceNameConfig.color
          }"></span>
          <label :key="`name-${index}`">{{sourceNameConfig.name}}</label>
          <span :key="`edit-btn-${index}`" class="edit-btn" @click="onEditBtnClick(sourceNameConfig)"><i class="el-icon-edit"></i></span>
          <span :key="`empty-${index}`"></span>
        </template>
      </template>
    </div>
  </div>
</div>
</template>

<script>
import BaseResult from './BaseResult'
import ChartStyle from '../../../../../../components/DataChart/ChartStyle'

export default {
  name: 'FactorFinger',
  label: '因子指纹',
  dataKey: 'FactorFinger',
  extends: BaseResult,
  data: () => ({
    sourceNames: Object.freeze([]),
    editSourceName: null,
    tmpSourceName: null,
    tmpSourceColor: null,
    selectOptions: Object.freeze([])
  }),
  computed: {
    sourceMap () {
      return this.sources.reduce((map, source) => {
        map[source.id] = source
        return map
      }, {})
    },
    sourceNameConfigs () {
      const {sourceMap} = this
      const {COLORS} = ChartStyle
      let index = 0
      return this.sourceNames.map(sourceName => {
        const source = sourceMap[sourceName]
        return {
          id: source ? source.id : sourceName,
          name: source ? source.name : sourceName,
          color: source ? source.color : COLORS[index++]
        }
      })
    }
  },
  methods: {
    renderChart () {
      const {factorSources} = this.shareData
      const {sourceMap} = this
      const factorIds = Object.freeze([...new Set(factorSources.map(factorSource => factorSource.factorId))])
      const sourceNames = this.sourceNames = Object.freeze([...new Set(factorSources.map(factorSource => factorSource.name))])
      const dataMap = factorSources.reduce((map, data) => {
        map[data.name][data.factorId] = data.percent
        return map
      }, sourceNames.reduce((map, name) => {
        map[name] = {}
        return map
      }, {}))
      const {COLORS} = ChartStyle
      const {factorMap} = this
      let index = 0
      const chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true
        },
        grid: {
          top: 40,
          right: 10,
          bottom: 40,
          left: 60,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          nameLocation: 'center',
          data: factorIds.map(factorId => factorMap[factorId].name),
          splitLine: {
            show: false
          },
          axisLine: {
            onZero: false
          },
          axisLabel: {
            rotate: 90
          }
        },
        yAxis: {
          type: 'value',
          name: `%`,
          nameLocation: 'center',
          nameGap: 40,
          max: 100,
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            onZero: false
          },
          axisTick: {
            show: true
          }
        },
        series: sourceNames.map(sourceName => {
          const data = dataMap[sourceName]
          const source = sourceMap[sourceName]
          return {
            name: source ? source.name : sourceName,
            type: 'bar',
            barMaxWidth: 30,
            stack: 'factor-finger',
            color: source ? source.color : COLORS[index++],
            data: factorIds.map(factorId => data[factorId])
          }
        })
      }

      setTimeout(() => {
        const {chart} = this.$refs
        chart.resize()
        chart.setOpt(chartOpt, true)
      }, 0)
    },
    onEditBtnClick (sourceNameConfig) {
      const {name} = sourceNameConfig
      const currentSourceMap = this.sourceNameConfigs.reduce((map, sourceNameConfig) => {
        map[sourceNameConfig.id] = sourceNameConfig
        return map
      }, {})
      const selectOptions = this.selectOptions = Object.freeze(this.sources.filter(source => !currentSourceMap[source.id]))

      if (selectOptions.length > 0) {
        this.tmpSourceName = selectOptions[0].id
        this.tmpSourceColor = selectOptions[0].color
      } else {
        this.tmpSourceColor = sourceNameConfig.color
      }

      this.editSourceName = name
    },
    onTmpSourceNameChange (sourceId) {
      const source = this.sourceMap[sourceId]
      this.tmpSourceColor = source.color
    },
    onOKBtnClick (sourceNameConfig) {
      const {shareData, editSourceName, tmpSourceName} = this

      shareData.factorSources.forEach(data => {
        if (data.name === editSourceName) {
          data.name = tmpSourceName
        }
      })

      shareData.timeSources.forEach(data => {
        if (data.name === editSourceName) {
          data.name = tmpSourceName
        }
      })

      this.editSourceName = null
      this.renderChart()
    },
    onCancelBtnClick (sourceNameConfig) {
      this.editSourceName = this.tmpSourceName = null
    }
  },
  mounted () {
    setTimeout(() => {
      this.renderChart()
    })
  }
}
</script>

<style lang="scss" scoped>
.factor-finger-wrapper {
  display: grid;
  grid-template-columns: auto minmax(max-content, 180px);
  grid-column-gap: 12px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }
}

.source-name-wrapper {
  padding: 40px 10px 40px 0;
  color: #606266;
}

.source-name-list {
  display: grid;
  grid-template-columns: 1em auto 1em 1em;
  grid-gap: 5px;
  align-items: center;
  line-height: 28px;

  > .color-section {
    padding-bottom: 100%;
  }

  > .ok-btn,
  > .cancel-btn,
  > .edit-btn {
    cursor: pointer;
  }

  > .ok-btn {
    color: #67C23A;

    &:hover {
      color: #85ce61;
    }

    &:active {
      color: #5daf34;
    }
  }

  > .edit-btn {
    &:hover {
      color: #66b1ff;
    }

    &:active {
      color: #3a8ee6;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/ResultComponents/03FactorFinger.vue